import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import DiceUtil from '../utils/DiceUtil';
import ItemContent from './ItemContent.json';
import withRoot from '../withRoot';
import ContentResultRenderer from './ContentResultRenderer';

const styles = theme => ({
    root: {
        margin: theme.spacing.unit,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
});

class ItemContentRoller extends Component {
    state = {
        resultCount: 1,
        item: -1,
        contentResults: null,
    };

    onSelectChange = name => (event) => {
        this.setState({ [name]: event.target.value });
    }

    addContentToArray(array, item, quantity) {
        for (let i = 0; i < array.length; i++) {
            let current = array[i];
            if (current.item === item) {
                current.quantity += quantity;
                return;
            }
        }

        array[array.length] = { quantity: quantity, item: item };
    }

    getContentRow(table, diceFaces) {
        let contentRow = null;
        const roll = DiceUtil.dice(diceFaces);
        for (let i = 0; i < table.length; i++) {
          contentRow = table[i];
          if (roll <= contentRow.rollMax) {
            break;
          }
        }
        return contentRow;
      }

    getContentFromItem(item) {
        const count = DiceUtil.diceLoop(item.faces, item.count) + item.offset;

        const content = [];
        for (let i = 0; i < count; i++) {
            let row = this.getContentRow(item.options, item.optionRoll);
            this.addContentToArray(content, row.name, 1);
        }
        return content;
    }

    rollContent() {
        const item = ItemContent.values[this.state.item];
        const resultCount = this.state.resultCount;

        const results = Array(resultCount);
        for (let i = 0; i < resultCount; i++) {
            results[i] = this.getContentFromItem(item);
        }

        this.setState({ contentResults: results });
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <div>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="results">Results</InputLabel>
                        <Select value={this.state.resultCount} onChange={this.onSelectChange("resultCount")} inputProps={{ id: 'results' }}>
                            {[1, 4, 6, 8, 10, 12, 20].map((value) => (
                                <MenuItem key={value} value={value}>{value}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="item">Items</InputLabel>
                        <Select value={this.state.item} onChange={this.onSelectChange("item")} inputProps={{ id: 'item' }}>
                            {ItemContent.values.map((value, index) => (
                                <MenuItem key={index} value={index}>{value.name}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    {this.state.item >= 0 ? (
                        <Button variant="raised" color="primary" onClick={() => this.rollContent()}>Roll Content</Button>
                    ) : null}
                </div>

                <ContentResultRenderer contentName={this.state.item >= 0 ? ItemContent.values[this.state.item].optionName : null} content={this.state.contentResults} />
            </div>
        );
    }
}

ItemContentRoller.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRoot("Item Content", withStyles(styles)(ItemContentRoller));


// WEBPACK FOOTER //
// ./src/item-helpers/ItemContentRoller.js